'use es6';

import globalNavHeight from 'nav-meta/global-nav-height';
export const MAIN_SECTION_PADDING_Y = 40;
export const MAIN_SECTION_PADDING_X = 48;
export const MAIN_SECTION_MAX_WIDTH = 1280;
export const DEFAULT_ICON_SIZE = 85;
export const SMALL_ICON_SIZE = 32;
export const MAX_INSTALLS_BUCKET = 10000;
export const DEFAULT_SEARCH_LENGTH = 45;
export const NEW_COLLECTION_SEARCH_LENGTH = 24;
export const ALL_COLLECTIONS_LENGTH = 3;
export const NAV_BAR_HEIGHT_INT = parseInt(globalNavHeight, 10);